import IpcRouter from '@shared/ipc/IpcRouter.ts'

export interface WorkOsIpcRouterType {
  getAccessToken: () => Promise<string>
  showSignIn: (screenHint?: 'sign-in' | 'sign-up') => Promise<void>
}

class WorkOsIpcRouter extends IpcRouter<WorkOsIpcRouterType> {
  constructor() {
    super('workos', {
      getAccessToken: true,
      showSignIn: true,
    })
  }
}

export default WorkOsIpcRouter
